// Generated from ./Restrictions.g4 by ANTLR 4.13.2

import {ParseTreeVisitor} from 'antlr4';


import { ParseContext } from "./RestrictionsParser.js";
import { ExprContext } from "./RestrictionsParser.js";
import { AndOrEqNeqContext } from "./RestrictionsParser.js";
import { OrContext } from "./RestrictionsParser.js";
import { AndContext } from "./RestrictionsParser.js";
import { MatchContext } from "./RestrictionsParser.js";
import { NeqContext } from "./RestrictionsParser.js";
import { EqContext } from "./RestrictionsParser.js";
import { EqNeqTermContext } from "./RestrictionsParser.js";
import { TermContext } from "./RestrictionsParser.js";
import { IdentContext } from "./RestrictionsParser.js";
import { OwnIdentContext } from "./RestrictionsParser.js";
import { StrContext } from "./RestrictionsParser.js";
import { WordContext } from "./RestrictionsParser.js";
import { NumberContext } from "./RestrictionsParser.js";


/**
 * This interface defines a complete generic visitor for a parse tree produced
 * by `RestrictionsParser`.
 *
 * @param <Result> The return type of the visit operation. Use `void` for
 * operations with no return type.
 */
export default class RestrictionsVisitor<Result> extends ParseTreeVisitor<Result> {
	/**
	 * Visit a parse tree produced by `RestrictionsParser.parse`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitParse?: (ctx: ParseContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.expr`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitExpr?: (ctx: ExprContext) => Result;
	/**
	 * Visit a parse tree produced by the `andOrEqNeq`
	 * labeled alternative in `RestrictionsParser.andOr`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitAndOrEqNeq?: (ctx: AndOrEqNeqContext) => Result;
	/**
	 * Visit a parse tree produced by the `or`
	 * labeled alternative in `RestrictionsParser.andOr`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitOr?: (ctx: OrContext) => Result;
	/**
	 * Visit a parse tree produced by the `and`
	 * labeled alternative in `RestrictionsParser.andOr`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitAnd?: (ctx: AndContext) => Result;
	/**
	 * Visit a parse tree produced by the `match`
	 * labeled alternative in `RestrictionsParser.eqNeq`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitMatch?: (ctx: MatchContext) => Result;
	/**
	 * Visit a parse tree produced by the `neq`
	 * labeled alternative in `RestrictionsParser.eqNeq`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitNeq?: (ctx: NeqContext) => Result;
	/**
	 * Visit a parse tree produced by the `eq`
	 * labeled alternative in `RestrictionsParser.eqNeq`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitEq?: (ctx: EqContext) => Result;
	/**
	 * Visit a parse tree produced by the `eqNeqTerm`
	 * labeled alternative in `RestrictionsParser.eqNeq`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitEqNeqTerm?: (ctx: EqNeqTermContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.term`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitTerm?: (ctx: TermContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.ident`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitIdent?: (ctx: IdentContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.ownIdent`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitOwnIdent?: (ctx: OwnIdentContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.str`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitStr?: (ctx: StrContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.word`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitWord?: (ctx: WordContext) => Result;
	/**
	 * Visit a parse tree produced by `RestrictionsParser.number`.
	 * @param ctx the parse tree
	 * @return the visitor result
	 */
	visitNumber?: (ctx: NumberContext) => Result;
}

